<template>
  <div>
    <head-con />
    <div class="main">
      <nav-con />
      <div class="view">
        <keep-alive><router-view v-if="$route.meta.keepAlive" /></keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
      </div>
    </div>
  </div>
</template>

<script>
import headCon from '@/components/nav/headcon'
import navCon from '@/components/nav/navcon'
export default {
  name: 'index',
  components: {
    headCon,
    navCon
  }
}
</script>

<style lang="scss">
.main{
  width: 100%;
  padding-top: 182px;
  position: relative;
  .view{
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
    padding-left: 160px;
    padding-right: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue